import { Component, OnInit, Input } from '@angular/core';
import { TableConfigs } from '../../../../../common/components/data-table/data-table.component';
import { CurrencyPipe } from '@angular/common';
import * as _ from 'lodash';
import { PlanConfigVO } from 'src/app/planner/interfaces/vo/PlanConfigVO';
import { DealExchangeResultVO } from 'src/app/planner/interfaces/vo/DealExchangeResultVO';
import { ExportService } from 'src/app/planner/services/export.service';
import { InvSrcAllocationResultVO } from 'src/app/planner/interfaces/vo/InvSrcAllocationResultVO ';
import { InventorySourceAllocationVO } from 'src/app/planner/interfaces/InventorySourceAllocationVO';

@Component({
  selector: 'inventory-allocation',
  templateUrl: './inventory-allocation.component.html',
  styleUrls: ['./inventory-allocation.component.scss']
})
export class InventoryAllocationComponent implements OnInit {
  @Input() public openAuction: InvSrcAllocationResultVO;
  @Input() public total: InventorySourceAllocationVO;
  @Input() public guaranteedDeals: InvSrcAllocationResultVO;
  @Input() public planDetails: PlanConfigVO;
  @Input() public privateDeals: DealExchangeResultVO;
  inventoryAllocationTypes: any;
  selectedType: any;
  showEnvironmentAllocation: boolean;
  showInvSrcAllocation: boolean = true;
  showSiteAllocation: boolean;
  isSelected: string;
  isCollapsed = false;

  public EnvironmentTableConfigs: TableConfigs = {
    disableSorting: true,
    uniqueIdAccessor: 'name',
    pageSize: 25, // default to 25
    isSelectionEnabled: false,
    isPaginationEnabled: false,
    showSummaryRow: false,
    endpoint: null,
    fetchStaticData: () => {
      return new Promise((resolve) => {
        resolve(
          {
            results: [
              {
                name: "Desktop Web",
                allocatedBudget: 1223,
                allocatedImpressions: 2132,
                eligibleRequestsPercent: 34,
                averageCPM: 342,
                winRate: 43,
                viewabilityRate: 343,
                maxAvails: 34324
              },
              {
                name: "Mobile App",
                allocatedBudget: 1223,
                allocatedImpressions: 2132,
                eligibleRequestsPercent: 34,
                averageCPM: 342,
                winRate: 43,
                viewabilityRate: 343,
                maxAvails: 34324
              },
              {
                name: "Connected TV",
                allocatedBudget: 222,
                allocatedImpressions: 356,
                eligibleRequestsPercent: 84,
                averageCPM: 342,
                winRate: 66,
                viewabilityRate: 652,
                maxAvails: 3568
              }
            ]
          }
        )
      })
    }

  };

  public siteTableConfigs: TableConfigs = {
    disableSorting: true,
    uniqueIdAccessor: 'name',
    pageSize: 25, // default to 25
    isSelectionEnabled: false,
    isPaginationEnabled: false,
    showSummaryRow: false,
    endpoint: null,
    fetchStaticData: () => {
      return new Promise((resolve) => {
        resolve(
          {
            results: [{
              name: "xyz.com",
              allocatedBudget: 1223,
              allocatedImpressions: 2132,
              eligibleRequestsPercent: 34,
              averageCPM: 342,
              winRate: 43,
              viewabilityRate: 343,
              maxAvails: 34324
            }]
          }
        )
      })
    }
  };

  public environmentColumns: any[] = [
    {
      Header: 'Environment',
      accessor: 'name',
      id: 'name'
    },
    {
      Header: 'Allocated Budget',
      accessor: row => {
        if (row.allocatedBudget) {
          return this.currencyPipe.transform(row.allocatedBudget, this.planDetails.currency, 'symbol', '1.2-10');
        } else {
          return '-'
        }
      },
      id: 'allocatedBudget'
    },
    {
      Header: 'Allocated Impression',
      accessor: 'allocatedImpressions',
      id: 'allocatedImpressions'
    },
    {
      Header: 'Average CPM',
      accessor: row => {
        if (row.averageCPM) {
          return this.currencyPipe.transform(row.averageCPM, this.planDetails.currency, 'symbol', '1.2-10');
        } else {
          return '-'
        }
      },
      id: 'averageCPM'
    },
    {
      Header: 'WinRate %',
      accessor: 'winRate',
      id: 'winRate'
    },
    {
      Header: '% Requests Eligible',
      accessor: 'eligibleRequestsPercent',
      id: 'eligibleRequestsPercent'
    },
    {
      Header: 'Viewable Rate',
      accessor: 'viewabilityRate',
      id: 'viewabilityRate'
    },
    {
      Header: 'Max Avails',
      accessor: 'maxAvails',
      id: 'maxAvails'
    },
  ];

  public siteColumns: any[] = [
    {
      Header: 'Site',
      accessor: 'name',
      id: 'name'
    },
    {
      Header: 'Average CPM',
      accessor: row => {
        if (row.averageCPM) {
          return this.currencyPipe.transform(row.averageCPM, this.planDetails.currency, 'symbol', '1.2-10');
        } else {
          return '-'
        }
      },
      id: 'averageCPM'
    },
    {
      Header: 'WinRate %',
      accessor: 'winRate',
      id: 'winRate'
    },
    {
      Header: 'Viewable Rate',
      accessor: 'viewabilityRate',
      id: 'viewabilityRate'
    },
    {
      Header: '% Requests Eligible',
      accessor: 'eligibleRequestsPercent',
      id: 'eligibleRequestsPercent'
    },
    {
      Header: 'Max Avails',
      accessor: 'maxAvails',
      id: 'maxAvails'
    },
  ];

  constructor(
    private currencyPipe: CurrencyPipe,
    private exportService: ExportService
  ) { }

  ngOnInit() {
    // this.inventoryAllocationTypes = InventoryAllocationType;
    // this.isSelected = this.inventoryAllocationTypes.inventorySource.name;
    if (this.openAuction && _.size(this.openAuction.results)) {
      this.openAuction.results = _.orderBy(this.openAuction.results, ['allocatedBudget'], ['desc']);
    }
    if (this.privateDeals && _.size(this.privateDeals.results)) {
      this.privateDeals.results = _.orderBy(this.privateDeals.results, ['allocatedBudget'], ['desc']);
    }
    if (this.guaranteedDeals && _.size(this.guaranteedDeals.results)) {
      this.guaranteedDeals.results = _.orderBy(this.guaranteedDeals.results, ['allocatedBudget'], ['desc']);
    }
  }

  exportAllocationData() {
    this.exportService.exportInventoryAllocationData(this.planDetails.id);
  }

  // renderInventoryAllocationView(event) {
  //   this.selectedType = event.target.value;
  //   this.showInvSrcAllocation = this.selectedType === this.inventoryAllocationTypes.inventorySource.name;
  //   this.showEnvironmentAllocation = this.selectedType === this.inventoryAllocationTypes.environment.name;
  //   this.showSiteAllocation = this.selectedType === this.inventoryAllocationTypes.site.name
  // }
}
